import Header from "../home/header" 
import Footer from "../home/footer" 
const policy=()=>{
    return(
        <>
            <Header/>
            <div className="container-fluid">
                <div className="container p-5">
                    <h1 className="display-5 ">Privacy Policy</h1>
                    <p className="text-secondary">
                        Effective Date: [6-June-2024]<br/><br/>

                        At Akcoda, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website [website URL], engage our services, or otherwise interact with us. Please read this policy carefully to understand our practices regarding your personal data and how we will treat it.<br/><br/>

                        <span className="text-dark">1. Information We Collect</span><br/>

                        - Personal Information: We may collect personal information that you voluntarily provide to us when you engage our services or communicate with us. This may include your name, email address, phone number, and other contact details.<br/>

                        - Usage Data: We may automatically collect certain information about your device and usage of our services, such as your IP address, browser type, pages visited, and referral URLs.<br/><br/>

                        <span className="text-dark">2. Use of Information</span><br/>

                        We may use the information we collect for various purposes, including to:<br/>

                        - Provide, operate, and maintain our services.<br/>
                        - Improve, personalize, and expand our services.<br/>
                        - Communicate with you, including responding to your inquiries and requests.<br/>
                        - Send you promotional emails about our services, special offers, or other information we think you may find interesting.<br/>
                        - Comply with legal obligations.<br/><br/>

                        <span className="text-dark">3. Sharing of Information</span><br/>

                        We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as set forth in this Privacy Policy or as required by law. We may share your information with:<br/>

                        - Service providers and partners who assist us in providing our services.<br/>
                        - Legal and regulatory authorities, if required to comply with legal obligations or protect our rights.<br/><br/>

                        <span className="text-dark">4. Security of Information</span><br/>

                        We take reasonable measures to protect the security of your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is completely secure, so we cannot guarantee absolute security.<br/><br/>

                        <span className="text-dark">5. Your Choices and Rights</span><br/>

                        -Opt-Out: You may opt-out of receiving promotional emails from us by following the instructions in those emails.<br/>
                        -Access and Rectification: You have the right to access, correct, or delete your personal information. You may contact us at [contact email] to request access or rectification.<br/>
                        - Data Retention: We will retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.<br/><br/>

                        <span className="text-dark">6. Links to Third-Party Websites</span><br/>

                        Our website may contain links to third-party websites or services that are not operated by us. This Privacy Policy does not apply to those third-party websites. We encourage you to review the privacy policies of those websites.<br/><br/>

                        <span className="text-dark">7. Changes to This Privacy Policy</span><br/>

                        We may update this Privacy Policy from time to time in order to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will notify you of any changes by posting the updated policy on our website with the effective date.<br/><br/>

                        <span className="text-dark">8. Contact Us</span><br/>

                        If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at [info@akcoda.in].<br/><br/>


                        Team Akcoda<br/>

                        This Privacy Policy was last updated on 23-June-2024.
                    </p>             
                </div>
            </div>
            <Footer/>
        </>
    )
}
export default policy